import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0067',
    ecrans: ['00-2']
});
